<template>
  <LayoutBaseContent class="max-w-7xl">
    <LayoutPanel>
      <UtilIframe :url="compUrl" class="mt-0 terms-iframe" />
    </LayoutPanel>
  </LayoutBaseContent>
</template>

<script>
import LayoutBaseContent from '@/components/layout/LayoutBaseContent'
import LayoutPanel from '@/components/layout/LayoutPanel'
import UtilIframe from '@/components/utils/UtilIframe'

export default {
  name: 'Policy',

  components: {
    LayoutBaseContent,
    LayoutPanel,
    UtilIframe
  },

  head: {
    title() {
      return {
        inner: 'Privacy Policy'
      }
    }
  },

  computed: {
    compUrl() {
      return 'https://docs.google.com/document/d/1Z0TBwBvIDjWaJe6lxGxz0tupgg6kBdupHZJAvTEaZ8A/pub?embedded=true'
    }
  }
}
</script>

<style lang="scss" scoped>
.terms-iframe {
  height: 90vh;
}
</style>